export const Lottie = () => null;
export type AnimationObject = unknown;
